import type { PostHog } from 'posthog-js';

export const usePosthog = () => {
    const app = useNuxtApp();
    const layoutStore = useLayoutStore();
    const posthog = computed(() => {
        if (layoutStore.isPosthogReady) {
            return (app.vueApp.config.globalProperties as any)
                .__posthog as PostHog;
        } else {
            return null;
        }
    });

    return posthog;
};
